import React, { useState, useEffect, useRef } from "react";
import "../../../../css/forms.css";
import logo from "../../../../assets/images/pass-logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import SuccessAlert from "../../../alerts/SuccessAlert";
import MessageModal from "../../../modal/MessageModal";

const PASSTemporary = () => {
  const [isloading, setIsloading] = useState(false);
  const [messageModal, setMessageModal] = useState(true);

  const name = useRef();
  const email = useRef();
  const tel = useRef();
  const [message, setMessage] = useState(null);
  const validateName = document.querySelector(".validate-name");
  const validateEmail = document.querySelector(".validate-email");
  const validatetel = document.querySelector(".validate-password");
  const mybutton = document.querySelector(".secondary-btn");
  const signUpContainer = document.querySelector(".signup-container");
  const requestUrl = "/register-temporary";

  let navigate = useNavigate();
  let timer1, timer2;

  const validateInputs = () => {
    if (
      name.current.value.trim() === "" ||
      email.current.value.trim() === "" ||
      tel.current.value.trim() === ""
    ) {
      setMessage("All fields are required");
      validateName.classList.add("alert-validate");
      validateEmail.classList.add("alert-validate");
      validatetel.classList.add("alert-validate");
    }
  };

  const handleSignUp = (e) => {
    e.preventDefault();

    if (
      name.current.value.trim() === "" ||
      email.current.value.trim() === "" ||
      tel.current.value.trim() === ""
    ) {
      mybutton.classList.add("headshake-anim");
      setMessage("All fields are required");
      validateName.classList.add("alert-validate");
      validateEmail.classList.add("alert-validate");
      validatetel.classList.add("alert-validate");
      return;
    } else {
      setMessage("");
      validateEmail.classList.remove("alert-validate");
      validatetel.classList.remove("alert-validate");
      mybutton.classList.remove("headshake-anim");
    }
    setMessage(null);

    const requestBody = {
      name: name.current.value,
      email: email.current.value,
      tel: tel.current.value,
    };
    setIsloading(!isloading);
    axios
      .post(requestUrl, requestBody)
      .then((response) => {
        signUpContainer.classList.add("animate-pageleft");
        setIsloading(isloading);
        timer1 = setTimeout(() => {
          setMessage("Thanks!");
           <SuccessAlert/>
     
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          signUpContainer.classList.remove("animate-pageleft");
          setIsloading(isloading);
          setMessage(error.response.data.message);
          validateEmail.classList.add("alert-validate");
          validatetel.classList.add("alert-validate");
          mybutton.classList.add("headshake-anim");
          console.log(error.response.data.message);
        } else if (error.response.status === 403) {
          signUpContainer.classList.remove("animate-pageleft");
          setIsloading(isloading);
          setMessage(error.response.data.message);
          validateEmail.classList.add("alert-validate");
          mybutton.classList.add("headshake-anim");
        } else {
          signUpContainer.classList.remove("animate-pageleft");
          validateEmail.classList.remove("alert-validate");
          validatetel.classList.remove("alert-validate");
          mybutton.classList.remove("headshake-anim");
          setMessage("Server not reachable");
        }
      });
  };

  const focusFunction = () => {
    const inputName = document.querySelector(".input-name");
    const inputEmail = document.querySelector(".input-email");
    const inputTel = document.querySelector(".input-password");

    if (name.current.value.trim() !== "") {
      inputName.classList.add("has-val");
    } else {
      inputName.classList.remove("has-val");
    }

    if (email.current.value.trim() !== "") {
      inputEmail.classList.add("has-val");
    } else {
      inputEmail.classList.remove("has-val");
    }

    if (tel.current.value.trim() !== "") {
      inputTel.classList.add("has-val");
    } else {
      inputTel.classList.remove("has-val");
    }

    if (name.current.value.trim() !== "") {
      setMessage("");
      validateName.classList.remove("alert-validate");
    }

    if (email.current.value.trim() !== "") {
      setMessage("");
      validateEmail.classList.remove("alert-validate");
    }
    if (tel.current.value.trim() !== "") {
      setMessage("");
      validatetel.classList.remove("alert-validate");
    }
  };

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    
    return () => {
      clearTimeout(timer1);
      
    };
  });
  return (
    <>
      <MessageModal show={messageModal} onHide={() => setMessageModal(false)} />
      <div className="container" style={{marginTop: "-60px"}}>
        <div className="">
          <div className="signup-container">
            <div className="signup-inner">
              <div className="signup-form-header">
                <img src={logo} alt="" />
                <div className="signup-form-title">
                  <h3></h3>
                </div>
              </div>

              <form className="signup-form" onSubmit={handleSignUp}>
                <div
                  className="wrap-input-signup validate-name"
                  data-validate={message}
                >
                  <input
                    type="text"
                    className="input-name"
                    ref={name}
                    onChange={focusFunction}
                  />
                  <span
                    className="focus-input-name"
                    data-placeholder="Name"
                  ></span>
                </div>
                <div
                  className="wrap-input-signup validate-email"
                  data-validate={message}
                >
                  <input
                    type="email"
                    className="input-email"
                    ref={email}
                    onChange={focusFunction}
                  />
                  <span
                    className="focus-input-email"
                    data-placeholder="Email"
                  ></span>
                </div>
                <div
                  className="wrap-input-signup validate-tel"
                  data-validate={message}
                >
                  <input
                    className="input-password"
                    type="text"
                    id="tel"
                    ref={tel}
                    onChange={focusFunction}
                  />
                  <span
                    className="focus-input-password"
                    data-placeholder="Phone number"
                  ></span>
                </div>
                {!isloading ? (
                  <button
                    type="submit"
                    className="secondary-btn"
                    onClick={validateInputs}
                  >
                    Submit
                  </button>
                ) : (
                  <div className="pass-loader-container">
                    <div className="pass-loader-mini"></div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PASSTemporary;
